module.exports = __webpack_public_path__ + "static/media/background-exotic-metals.2214f07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-exotic-metals.jpg
// module id = 1015
// module chunks = 0